const stylesheet = () => ({
  radioList: {
    display: 'flex',
    justifyContent: (props: any) => props.justify,
    flexDirection: (props: any) => props.direction,
    '& .radioHolder': {
      margin: (props: any) => (props.direction === 'row' ? '0 23px' : '10px 0'),
      display: 'flex',
      alignItems: 'center',
    },
    '& .radioHolder:first-child': {
      marginLeft: '0',
      marginTop: '0',
    },
    '& .radioHolder:last-child': {
      marginBottom: '0',
      marginRight: '0',
    },
  },
  error: {
    borderColor: '#e60000 !important',
    transition: 'border 500ms',
  },
  label: {
    height: '19px',
    color: '#6373A4',
    fontSize: '12px',
    fontWeight: '500',
    cursor: 'pointer',
    letterSpacing: 0,
    lineHeight: '15px',
  },
  labelValue: {
    height: '19px',
    width: '33px',
    color: '#6373A4',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '19px',
    float: 'right',
    paddingRight: '21px',
  },
  radioInput: {
    position: 'absolute',
    visibility: 'hidden',
    width: '18px',
    height: '18px',
    marginRight: '10px',
    paddingLeft: '10px',
  },
  title: {
    margin: 0,
    marginLeft: '-16px',
    display: 'block',
    textAlign: 'left',
    marginBottom: '14px',
    textTransform: 'uppercase',
    color: '#223762',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 700,
  },
  check: {
    boxSizing: 'border-box',
    top: '4px',
    marginRight: '10px',
    display: 'inline-block',
    width: '18px',
    height: '18px',
    border: 'solid 2px #b7c1e1',
    backgroundColor: '#fff',
    borderRadius: '100%',
    position: 'relative',
    transformOrigin: '50% 50%',
    transition: 'border 500ms',
  },
  radioHolder: {
    display: 'inherit',
  },
  inside: {
    transform: 'scale(0,0)',
    position: 'absolute',
    borderRadius: '100%',
    width: '8px',
    height: '8px',
    backgroundColor: '#085fe5',
    left: '3px',
    top: '3px',
    transformOrigin: '50% 50%',
  },
  '@media (max-width: 900px)': {
    title: {
      fontSize: '10px',
      marginLeft: 0,
    },
    radioList: {
      paddingLeft: '9px',
    },
  },
});

export default stylesheet;
